var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormLogin',{ref:"formLogin",attrs:{"titleClass":"amber"},on:{"login":_vm.login,"guest-login":_vm.guestUserLogin},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("UserLogin")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }